import styled from 'styled-components';
import { fadeIn, slideUp } from '~styles/animations';
import { COLORS, SURFACES } from '~styles/tokens';


export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 15vh;
  z-index: 9999;
  animation: ${fadeIn} 0.15s ease-out;
`;

export const PaletteContainer = styled.div`
  width: 100%;
  max-width: 700px;
  background: ${SURFACES.overlay};
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  animation: ${slideUp} 0.2s ease-out;
  position: relative;
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 1rem;
  top: 1.125rem;
  color: ${COLORS.textMuted};

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 1rem 1rem 1rem 3rem;
  font-size: 1rem;
  border: none;
  border-bottom: 1px solid ${COLORS.borderDefault};
  outline: none;

  &::placeholder {
    color: ${COLORS.textMuted};
  }
`;

export const ResultsList = styled.ul`
  list-style: none;
  padding: 0.5rem;
  margin: 0;
  max-height: 400px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.borderStrong};
    border-radius: 3px;
  }
`;

interface ResultItemProps {
  $selected: boolean;
}

export const ResultItem = styled.li<ResultItemProps>`
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  background-color: ${({ $selected }) => ($selected ? COLORS.primary10 : 'transparent')};

  &:hover {
    background-color: ${COLORS.primary10};
  }
`;

export const ResultIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background-color: ${COLORS.neutral100};
  border-radius: 6px;
  margin-right: 0.75rem;
  color: ${COLORS.textTertiary};
`;

export const ResultLabel = styled.span`
  flex: 1;
  font-size: 0.9375rem;
  color: ${COLORS.textPrimary};
`;

export const ResultShortcut = styled.span`
  font-size: 0.75rem;
  color: ${COLORS.textMuted};
  background-color: ${COLORS.neutral100};
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-family: monospace;
`;

export const NoResults = styled.li`
  padding: 2rem 1rem;
  text-align: center;
  color: ${COLORS.textMuted};
  font-size: 0.9375rem;
`;

export const Footer = styled.div`
  display: flex;
  gap: 1.5rem;
  padding: 0.75rem 1rem;
  background-color: ${SURFACES.inset};
  border-top: 1px solid ${COLORS.borderDefault};
  font-size: 0.75rem;
  color: ${COLORS.textTertiary};

  span {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  @media (max-width: 480px) {
    display: none;
  }
`;

export const Kbd = styled.kbd`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  height: 1.25rem;
  padding: 0 0.375rem;
  font-family: inherit;
  font-size: 0.6875rem;
  background: ${SURFACES.card};
  border: 1px solid ${COLORS.borderStrong};
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
`;
